import React from 'react'
import { useEntity } from '../helpers/selectors'
import { cf2imgix } from '../helpers/imgix-image'
import Checklist from '../checklist'
import { Button, Image } from '../../atoms'

const PreviewHeroCard = ({ title, checklist, ctaLink, ctaText, bgImage }): JSX.Element => {
  const image = useEntity(bgImage)
  const backgroundImage = cf2imgix(image?.file?.url)
  const checklistEntity = useEntity(checklist)

  return (
    <div className='hero-card__preview'>
      <div className='hero-card__preview-content'>
        <h2>{title}</h2>
        {checklist && <Checklist {...checklistEntity} />}
        {ctaText && ctaLink && (
          <Button variant='primary' href={ctaLink} withIcon={true} size='lg'>
            {ctaText}
          </Button>
        )}
      </div>
      <div className='hero-card__preview-image'>
        <Image src={backgroundImage} variant='large' alt={title} critical={false} />
      </div>
    </div>
  )
}

export default PreviewHeroCard
